export var EmployeeCardRoutes = {
    "/employee-card/:user_id?brandId&tab&view_status&expanded_tab": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.employee-card",
        "views": {
            "body": {
                "component": "employeeCardComponent",
            }
        },
        "route_styles": {
            styles: ["employee-card"],
            framework: "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Team"
            }
        ],
        "params": {
            tab: {
                dynamic: true,
                value: "employeeInfo"
            },
            brandId: {
                dynamic: true
            },
            expanded_tab: {
                dynamic: true
            },
            user_id: {
                dynamic: true,
                value: ""
            },
            view_status: {
                dynamic: true,
                value: "ACTIVE"
            }
        },
        "type": "frontend",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./employee-card.module.js");
                }
            }
        ]
    },
    "/people-platform": {
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./employee-card.module.js");
                }
            },
        ]
    },
    "/lms": {
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./employee-card.module.js");
                }
            },
        ]
    }
};